var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeart = function SvgIconHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.04 1.07a3.216 3.216 0 0 0-3.206 3.227c0 2.167 1 3.903 2.259 5.193 1.265 1.296 2.76 2.108 3.655 2.414l.005.002a.8.8 0 0 0 .247.031.8.8 0 0 0 .247-.031l.005-.002c.895-.306 2.39-1.118 3.655-2.414 1.26-1.29 2.26-3.026 2.26-5.193A3.216 3.216 0 0 0 10.96 1.07a3.19 3.19 0 0 0-2.558 1.292.5.5 0 0 1-.803 0A3.18 3.18 0 0 0 5.04 1.07M.833 4.297C.833 1.963 2.715.07 5.04.07 6.198.07 7.243.541 8 1.3A4.18 4.18 0 0 1 10.96.07c2.325 0 4.207 1.893 4.207 4.227 0 2.5-1.16 4.473-2.544 5.892-1.377 1.41-3.007 2.305-4.046 2.66a1.8 1.8 0 0 1-.577.088c-.185 0-.394-.023-.577-.088-1.038-.355-2.668-1.25-4.046-2.66C1.993 8.77.833 6.797.833 4.297",
    clipRule: "evenodd"
  })));
};
export default SvgIconHeart;